import React, { useState } from 'react'
import { PlayIcon } from '@heroicons/react/24/outline'
import { getVideoThumbnail } from '@/utils/urlUtils'

interface VideoThumbnailProps {
  url: string
  title?: string
  className?: string
  onClick?: () => void
}

/** 동영상 링크 썸네일. 썸네일을 못 가져오면 아무것도 렌더링하지 않는다. */
const VideoThumbnail: React.FC<VideoThumbnailProps> = ({
  url,
  title,
  className = 'w-full h-32 object-cover rounded-md',
  onClick,
}) => {
  const [imageError, setImageError] = useState(false)
  const videoInfo = getVideoThumbnail(url)

  if (!videoInfo || imageError) {
    return null
  }

  return (
    <div
      className="group relative cursor-pointer"
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onClick?.()
        }
      }}
    >
      <img
        src={videoInfo.thumbnail}
        alt={title || 'Video thumbnail'}
        className={className}
        onError={() => setImageError(true)}
      />
      {/* YouTube 플레이 버튼 오버레이 */}
      {videoInfo.platform === 'youtube' && (
        <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-20 transition-all duration-200 group-hover:bg-opacity-30">
          <div className="transform rounded-full bg-red-600 p-3 shadow-lg transition-transform duration-200 group-hover:scale-110">
            <PlayIcon className="h-6 w-6 text-white" />
          </div>
        </div>
      )}
    </div>
  )
}

export default VideoThumbnail
